(function () {
  'use strict';

  var SELECTOR = '[data-pss]';
  var syncTimer = null;

  /* Prevent duplicate global listeners if the snippet is rendered twice. */
  if (window.__PSS_BOOTED__) {
    if (typeof window.__PSS_INIT__ === 'function') {
      window.__PSS_INIT__(document);
    }
    return;
  }

  window.__PSS_BOOTED__ = true;

  function parseVariants(root) {
    var element = root.querySelector('[data-pss-variant-data]');

    if (!element) {
      return [];
    }

    try {
      var parsed = JSON.parse(element.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      if (window.console && typeof window.console.warn === 'function') {
        window.console.warn('[Product Sales + Stock] Invalid variant data.', error);
      }
      return [];
    }
  }

  function findVariant(instance, variantId) {
    var target = String(variantId || '');
    var i;

    for (i = 0; i < instance.variants.length; i += 1) {
      if (String(instance.variants[i].id) === target) {
        return instance.variants[i];
      }
    }

    return null;
  }

  function setStockVisibility(instance, show) {
    if (!instance.stockRow) {
      return;
    }

    if (show) {
      instance.stockRow.removeAttribute('hidden');
    } else {
      instance.stockRow.setAttribute('hidden', 'hidden');
    }
  }

  function updateStock(instance, variantId) {
    var variant = findVariant(instance, variantId);

    if (!variant || !variant.inventory_management) {
      setStockVisibility(instance, false);
      return;
    }

    var quantity = Number(variant.inventory_quantity);

    if (!isFinite(quantity)) {
      setStockVisibility(instance, false);
      return;
    }

    var shouldShow =
      quantity > 0 &&
      quantity <= instance.stockThreshold;

    if (!shouldShow) {
      setStockVisibility(instance, false);
      return;
    }

    if (
      instance.stockCount &&
      instance.stockCount.textContent !== String(quantity)
    ) {
      instance.stockCount.textContent = String(quantity);
    }

    setStockVisibility(instance, true);

    instance.root.setAttribute(
      'data-current-variant',
      String(variantId)
    );
  }

  function getVariantIdFromEvent(event) {
    if (!event) {
      return null;
    }

    var detail = event.detail || null;

    if (!detail) {
      return null;
    }

    if (detail.variant && detail.variant.id) {
      return String(detail.variant.id);
    }

    if (detail.variantId) {
      return String(detail.variantId);
    }

    if (detail.id) {
      return String(detail.id);
    }

    return null;
  }

  function findVariantIdFromForms(instance) {
    var root = instance.root;
    var section = null;

    if (typeof root.closest === 'function') {
      section = root.closest('.shopify-section');
    }

    var scopes = [];
    var i;
    var j;

    if (section) {
      scopes.push(section);
    }

    scopes.push(document);

    for (i = 0; i < scopes.length; i += 1) {
      var inputs = scopes[i].querySelectorAll(
        'form[action*="/cart/add"] input[name="id"], input[name="id"][form]'
      );

      for (j = 0; j < inputs.length; j += 1) {
        var value = inputs[j].value;

        if (value && findVariant(instance, value)) {
          return String(value);
        }
      }
    }

    return null;
  }

  function findVariantIdFromUrl(instance) {
    var match = window.location.search.match(/[?&]variant=([^&]+)/);

    if (!match || !match[1]) {
      return null;
    }

    var value = decodeURIComponent(match[1]);

    return findVariant(instance, value)
      ? String(value)
      : null;
  }

  function syncInstance(instance) {
    var variantId =
      findVariantIdFromForms(instance) ||
      findVariantIdFromUrl(instance) ||
      instance.root.getAttribute('data-current-variant');

    if (variantId) {
      updateStock(instance, variantId);
    }
  }

  function syncAll() {
    var roots = document.querySelectorAll(SELECTOR);
    var i;

    for (i = 0; i < roots.length; i += 1) {
      if (roots[i].__pssInstance) {
        syncInstance(roots[i].__pssInstance);
      }
    }
  }

  function scheduleSync() {
    if (syncTimer) {
      window.clearTimeout(syncTimer);
    }

    syncTimer = window.setTimeout(function () {
      syncTimer = null;
      syncAll();
    }, 0);
  }

  function init(scope) {
    scope = scope || document;

    var roots = [];
    var found;
    var i;

    if (
      scope.nodeType === 1 &&
      typeof scope.matches === 'function' &&
      scope.matches(SELECTOR)
    ) {
      roots.push(scope);
    }

    if (typeof scope.querySelectorAll === 'function') {
      found = scope.querySelectorAll(SELECTOR);

      for (i = 0; i < found.length; i += 1) {
        roots.push(found[i]);
      }
    }

    for (i = 0; i < roots.length; i += 1) {
      if (roots[i].__pssInstance) {
        continue;
      }

      var instance = {
        root: roots[i],
        stockRow: roots[i].querySelector('[data-pss-stock-row]'),
        stockCount: roots[i].querySelector('[data-pss-stock-count]'),
        stockThreshold: parseInt(
          roots[i].getAttribute('data-stock-threshold') || '50',
          10
        ),
        variants: parseVariants(roots[i])
      };

      roots[i].__pssInstance = instance;
      syncInstance(instance);
    }
  }

  window.__PSS_INIT__ = init;

  function handleVariantEvent(event) {
    var variantId = getVariantIdFromEvent(event);

    if (!variantId) {
      scheduleSync();
      return;
    }

    var roots = document.querySelectorAll(SELECTOR);
    var i;

    for (i = 0; i < roots.length; i += 1) {
      var instance = roots[i].__pssInstance;

      if (instance && findVariant(instance, variantId)) {
        updateStock(instance, variantId);
      }
    }
  }

  /* Common variant events used by Shopify themes. */
  document.addEventListener('variant:change', handleVariantEvent);
  document.addEventListener('variant:changed', handleVariantEvent);
  document.addEventListener('variantChange', handleVariantEvent);
  document.addEventListener('product:variant-change', handleVariantEvent);

  /* Generic fallback: most themes update the product form after a change. */
  document.addEventListener(
    'change',
    function () {
      scheduleSync();

      /* Some themes update the hidden variant id asynchronously. */
      window.setTimeout(syncAll, 80);
    },
    true
  );

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    scheduleSync();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
